import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

import { getRebalancingSchedulesQueryKey } from 'hooks/queries/scheduled-rebalancing/useRebalancingSchedulesQuery';

type UseDeleteScheduleMutationProps = {
  onSuccess?: () => void;
  onError?: () => void;
};

export const useDeleteScheduleMutation = ({
  onSuccess,
  onError,
}: UseDeleteScheduleMutationProps = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => {
      return apiClient.scheduledRebalancing.deleteSchedule({ id });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getRebalancingSchedulesQueryKey(),
      });
      onSuccess?.();
    },
    onError,
  });
};
